import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import JiraAuthentication from "./JiraAuthentication.vue";
import GitHubAuthentication from "./GitHubAuthentication.vue";


/**
 * Allows for selecting which type of authentication to import from.
 */
const __default__ = {
  name: "AuthenticationSelector",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["input"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(JiraAuthentication, {
      inactive: false,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('input', 'Jira')))
    }),
    _createVNode(GitHubAuthentication, {
      inactive: false,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('input', 'GitHub')))
    })
  ], 64))
}
}

})